import type { Poll } from 'schema/poll';
import { ICState } from 'schema/state';
import { SendInitPoll, SendNextStep } from '../machine';

type DataType = {
  sendNextStep: SendNextStep;
  state: ICState;
  poll: Poll;
};

export async function onNextStep({ sendNextStep, state, poll }: DataType): Promise<{ poll: Poll; state: ICState }> {
  const result = await sendNextStep({ poll, state });
  poll = { ...poll };

  /** Добавляем следующие сущности в опрос, после выполнения next */
  for (const key of ['questionDecks', 'questions', 'groups', 'finals', 'sets'] as const) {
    poll = addNextResultToPollByKey(poll, key, result.patch[key]);
  }

  /** У polls.site есть контракт для poll и state, он просто отбросит поля, которых нет в контракте */
  return {
    poll,
    state: {
      ...state,
      ...result.state,
      answersStack: result.state.answersStack.map(stack => ({
        ...stack,
        answeredIds: stack.answeredIds ?? undefined, // Нужно подменить null на undefined
      })),
    },
  };
}

function addNextResultToPollByKey<Key extends 'questionDecks' | 'questions' | 'groups' | 'finals' | 'sets'>(
  poll: Poll,
  key: Key,
  value: Poll[Key] | undefined,
) {
  const existingItems = poll[key] || [];
  const existingIds = new Set(existingItems.map(item => item.id));

  const uniqueNewItems = value?.filter(item => !existingIds.has(item.id));

  if (uniqueNewItems && uniqueNewItems.length > 0) {
    return {
      ...poll,
      [key]: [...existingItems, ...uniqueNewItems],
    };
  }
  return poll;
}

type InitServerPassPollArgs = {
  sendInitPoll: SendInitPoll;
  state: ICState;
  poll: Poll;
};

export async function onInitPoll({ sendInitPoll, state, poll }: InitServerPassPollArgs) {
  return await sendInitPoll({ poll, state });
}
